﻿import { GuiAuswertung } from "./GuiAuswertung";
import { Chart } from "../chart-setup";
import { IChartData } from "../Interface/IChartData"

    export class GuiAuswertungAbfallKostenartMonat extends GuiAuswertung {
        chartKosten?: Chart;

        constructor() {
            super("GuiAuswertungAbfallKostenartMonat");
        }

        draw() {

            const ctx = document.getElementById("chartKosten") as HTMLCanvasElement;
            if (this.chartKosten != undefined) {
                this.chartKosten.destroy();
            }

            const jsonData = (<HTMLInputElement>document.getElementById("jsonChartDataKosten")).value;
            if (jsonData == undefined || jsonData === "null") { return; }


            const chartData = JSON.parse(jsonData) as IChartData;

            const data = {
                labels: chartData.labels,
                datasets: [{
                    label: "Kosten",
                    data: chartData.values,
                    backgroundColor:"#044135",
                    borderColor: "#044135",
                    hoverOffset: 4
                }, ...(chartData.values2 && chartData.values2.length > 0 ? [{
                    label: "Kosten Vorjahr",
                    data: chartData.values2,
                    backgroundColor:"#0CAD8E",
                    borderColor: "#0CAD8E",
                    hoverOffset: 4
                }] : [])]
            };

            const config= this.CreateLineConfig(data);

            this.chartKosten = new Chart(ctx, config);

        }
    }




